import React from 'react';
import './choice-grid.css';

const ChoiceGrid = ({ children, groupTitle, totalChoicesCount }) => {
  const childrenArray = React.Children.toArray(children);
  const childCount = React.Children.count(children);
  
  const gridSizeClass = (totalChoicesCount || childCount) > 4 ? 'grid-many-items' : 'grid-few-items';
  
  const hasSelection = childrenArray.some(child => 
    child.props && child.props.isSelected === true
  );

  const gridClasses = `choice-grid ${gridSizeClass} ${hasSelection ? 'has-selection' : ''}`;

  return (
    <div className="choice-grid-container">
      <div 
        className={gridClasses}
        data-has-selection={hasSelection ? 'true' : 'false'}
        data-group-title={groupTitle || 'default'}
        data-child-count={childCount}
        data-total-choices={totalChoicesCount || childCount}
      >
        {children}
      </div>
    </div>
  );
};

ChoiceGrid.defaultProps = {
  totalChoicesCount: null,
};

export default ChoiceGrid;